import { Request } from "@/axios/request";
import { apiUrl, fileUrl } from "./path";
/**
 * 后台的验证码配置
 */
export function getCaptchaConfig() {
  return Request.request({
    url: fileUrl("captcha/api/math"),
    baseURL: "/",
  });
}

/**
 * 直接请求数据
 */
export function getSchema(path, data) {
  return Request.get(apiUrl(path), { params: data });
}

/**
 * 通用 post 请求
 */
export function postRequest(path, data) {
  return Request.post(apiUrl(path), data);
}

/**
 * 读取全局翻译
 */
export function getGlobalSchema(path) {
  return Request.request({
    url: fileUrl(path),
    baseURL: "/",
  });
}
